"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedAccountNumber = exports.isBankAccountValidFormat = exports.getDoesContainUnkownCharacters = exports.getDoesContainEmoji = exports.getAllTermDepositTransactionsTitle = exports.decodeBase64String = exports.isBase64 = exports.stringToInt = exports.isString = exports.stripCharacter = exports.capitalizeFirstCharacter = exports.getFirstWordFromSentance = exports.getFirstCharacter = void 0;
var buffer_1 = require("buffer");
var Regex_1 = require("./Regex");
var getFirstCharacter = function (input) {
    return input.charAt(0);
};
exports.getFirstCharacter = getFirstCharacter;
var getFirstWordFromSentance = function (sentance) {
    var _a;
    return (_a = sentance.split(' ')[0]) !== null && _a !== void 0 ? _a : sentance;
};
exports.getFirstWordFromSentance = getFirstWordFromSentance;
var capitalizeFirstCharacter = function (input) { return input.charAt(0).toUpperCase() + input.slice(1); };
exports.capitalizeFirstCharacter = capitalizeFirstCharacter;
var stripCharacter = function (str, regex) {
    if (regex === void 0) { regex = Regex_1.RegexConstants.NotNumber; }
    return str.trim().replace(regex, '');
};
exports.stripCharacter = stripCharacter;
var isString = function (value) {
    return typeof value === 'string' || value instanceof String;
};
exports.isString = isString;
var stringToInt = function (stringToParse) {
    return Number.isInteger(Number.parseInt(stringToParse, 10)) ? Number.parseInt(stringToParse, 10) : 0;
};
exports.stringToInt = stringToInt;
var isBase64 = function (stringToCheck) {
    return Regex_1.RegexConstants.IsBase64.test(stringToCheck);
};
exports.isBase64 = isBase64;
var decodeBase64String = function (stringToDecode) {
    if ((0, exports.isBase64)(stringToDecode)) {
        return buffer_1.Buffer.from(stringToDecode, 'base64').toString('utf-8');
    }
    return stringToDecode;
};
exports.decodeBase64String = decodeBase64String;
var getAllTermDepositTransactionsTitle = function (length) {
    return "S\u00ED\u00F0ustu ".concat(length, " f\u00E6rslur");
};
exports.getAllTermDepositTransactionsTitle = getAllTermDepositTransactionsTitle;
var getDoesContainEmoji = function (value) {
    return Regex_1.RegexConstants.Emoji.test(value);
};
exports.getDoesContainEmoji = getDoesContainEmoji;
var getDoesContainUnkownCharacters = function (value) {
    return !Regex_1.RegexConstants.AlphanumSpecialAndIcelandicCharacters.test(value);
};
exports.getDoesContainUnkownCharacters = getDoesContainUnkownCharacters;
var isBankAccountValidFormat = function (str) {
    if (str === '') {
        return true;
    }
    return /^[0-9-]+$/.test(str);
};
exports.isBankAccountValidFormat = isBankAccountValidFormat;
var getFormattedAccountNumber = function (account) {
    return "".concat(account.bank, "-").concat(account.branch, "-").concat(account.account);
};
exports.getFormattedAccountNumber = getFormattedAccountNumber;
//# sourceMappingURL=StringUtils.js.map